import styles from './QuizProgress.module.css';

interface Props {
  current: number;
  total: number;
}

export function QuizProgress({ current, total }: Props) {
  return (
    <div className={styles.progress}>
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={`${styles.bar} ${i <= current ? styles.filled : ''}`}
        />
      ))}
    </div>
  );
}
